export const currencyBRL = (value: any) => {
  if (value === null || value === undefined) {
    value = 0;
  }
  const formattedValue = value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  return formattedValue;
};

export const formatarParaReal4 = (value: any) => {
  if (value === null || value === undefined) {
    value = 0;
  }
  const formattedValue = value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });
  return formattedValue;
};

export const formatPercent = (value: number) => {
  const formattedValue = Number(value).toLocaleString(undefined, {
    style: "percent",
    minimumFractionDigits: 2,
  });
  return formattedValue;
};

export const formatPercentCG = (value: number) => {
  const formattedValue = Number(value).toLocaleString(undefined, {
    style: "percent",
    minimumFractionDigits: 5,
  });
  return formattedValue;
};

export const formatNumber = (value: any) => {
  if (value === null || value === undefined) {
    value = 0;
  }
  const formattedValue = value.toLocaleString("pt-BR", {
    currency: "BRL",
  });
  return formattedValue;
};

export const formatFator = (value: number) => {
  const formattedValue = value.toLocaleString("pt-BR", {
    currency: "BRL",
    minimumFractionDigits: 5,
  });
  return formattedValue;
};

export const realParaNumber = (texto: string) => {
  if (typeof texto === "string") {
    // Verifica se o valor está no formato "X.Y" sem vírgula ou ponto decimal
    if (/^\d+(\.\d+)?$/.test(texto)) {
      return parseFloat(texto);
    }
    //verifica se o separador dos centavos é um ponto (.) e substitui por uma virgula (,)
    if (texto.charAt(texto.length - 3) === "." && /^\d{2}$/.test(texto.slice(-2))) {
      texto = texto.slice(0, -3) + "," + texto.slice(-2);
    }

    var compativelComParseFloat = texto.toString().replace("R$", "").replaceAll(".", "").replace(",", ".");
    const valor = parseFloat(compativelComParseFloat);
    return valor;
  } else return texto;
};

export const percentParaNumber = (texto: string) => {
  var compativelComParseFloat = texto.toString().replace("%", "");
  compativelComParseFloat = compativelComParseFloat.replace(",", ".");
  const valor = parseFloat(compativelComParseFloat) / 100;
  return valor;
};
